import React from "react";

import { ExperimentOutlined } from "@ant-design/icons";
import { Progress } from "antd";

import { CreditsCountGroup } from "../subscription/components/CreditsCount";
import UsageStatusLabel from "../subscription/components/UsageStatusLabel";

import {
  getSubscriptionTierUsage,
  getUsageProgressColor,
  getUsageTierStatus,
} from "../utils";

import "./CategorizedCreditUsage.css";

const CATEGORY_ICONS = {
  microbiology: <ExperimentOutlined />,
  chemistry: <ExperimentOutlined />,
};

export default function CategorizedCreditUsage({
  category,
  billingMode = "subscription",
  topupPlan = false,
  showUsageMeter = true,
  countLabel = "remaining",
  usedLabel = "",
}) {
  if (!category) {
    return null;
  }

  return (
    <section className="CategorizedCreditUsage">
      <div className="CategorizedCreditUsage__Header">
        <h3 className="CategorizedCreditUsage__Name">
          <span
            className={`CategorizedCreditUsage__Icon CategorizedCreditUsage__Icon--${category.key}`}
          >
            {CATEGORY_ICONS[category.key]}
          </span>
          {category.name}
        </h3>
        {category.testsLabel && (
          <p className="CategorizedCreditUsage__Tests">{category.testsLabel}</p>
        )}
      </div>

      <div className="CategorizedCreditUsage__Tiers">
        {(category.tiers || []).map((tier) => {
          const {
            used, total, remaining, percent, poolCredits,
          } = getSubscriptionTierUsage(tier, { billingMode, topupPlan });
          const status = showUsageMeter ? getUsageTierStatus(used, total) : undefined;
          const tierClassName = [
            "CategorizedCreditUsage__Tier",
            showUsageMeter ? "" : "CategorizedCreditUsage__Tier--countsOnly",
          ].filter(Boolean).join(" ");

          return (
            <div className={tierClassName} key={tier.name}>
              <span className="CategorizedCreditUsage__TierName">{tier.name}</span>
              {showUsageMeter && (
                <>
                  <UsageStatusLabel
                    status={status}
                    used={used}
                    total={total}
                  />
                  <div className="CategorizedCreditUsage__ProgressContainer">
                    <Progress
                      percent={percent}
                      showInfo={false}
                      strokeColor={getUsageProgressColor(used, total)}
                      trailColor="var(--color-bg-tertiary)"
                      className="CategorizedCreditUsage__Progress"
                    />
                  </div>
                  <span className="CategorizedCreditUsage__TierPercent">{`${percent}%`}</span>
                </>
              )}
              <CreditsCountGroup
                used={used}
                total={total}
                poolCredits={poolCredits}
                remaining={remaining}
                status={status}
                warningThreshold={showUsageMeter ? 10 : null}
                muteEmpty={showUsageMeter}
                label={countLabel}
                usedLabel={usedLabel}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
